import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { LicenseService } from '../services/license.service';
import { AuthService } from '../services/auth.service';

export const licenseGuard: CanActivateFn = () => {
  const licenseService = inject(LicenseService);
  const router = inject(Router);
  const authService = inject(AuthService);

  // Super admin bypasses license check
  if (authService.userRole() === 'SUPER_ADMIN') {
    return true;
  }

  // No license loaded yet → allow and load
  if (!licenseService.license()) {
    return licenseService.validateOnStartup().pipe(
      map(() => {
        if (licenseService.isExpired() || licenseService.isTrialExpired()) {
          return router.createUrlTree(['/license/expired']);
        }
        if (!licenseService.isValid()) {
          return router.createUrlTree(['/license/activate']);
        }
        return true;
      })
    );
  }

  // License expired
  if (licenseService.isExpired() || licenseService.isTrialExpired()) {
    return router.createUrlTree(['/license/expired']);
  }

  // No valid license
  if (!licenseService.isValid()) {
    return router.createUrlTree(['/license/activate']);
  }

  return true;
};
